// extracted by mini-css-extract-plugin
export var container = "_ms-0";